export default "__VITE_ASSET__D92ol902__"